// =============================================================================
// Legacy URL → New URL redirect map.
//
// Sourced from Google Search Console Coverage drilldown (May 2026). All of
// these were live on the previous Wix-style site (note the `intrototrainsystems`,
// `PTS`, `*-pXXXXXXXXX` and Wix demo-blog patterns). They now serve a React 404,
// which preserves crawl-budget but doesn't pass remaining link equity to the new
// pages. We render a `<Navigate to="X" replace />` for each so users coming from
// old SERP results, bookmarks or social shares land on the right new page
// immediately, and Google sees a same-host alternate that points to a canonical
// new URL via <Seo>.
//
// IMPORTANT: This is NOT a true HTTP 301 — for proper SEO equity flow and to
// get Google to fully drop the old URLs from Coverage, set up Cloudflare Bulk
// Redirects (or Page Rules) using the same map. See LEGACY_REDIRECTS_CF.csv.
// =============================================================================

export const LEGACY_REDIRECTS = [
  // ----- Old homepage variants ----------------------------------------------
  ["/home",                                                                                       "/"],
  ["/tdf",                                                                                        "/"],
  ["/tdf85b04595",                                                                                "/"],
  ["/rail-i",                                                                                     "/"],
  ["/rail-cv",                                                                                    "/"],
  ["/producs-and-services",                                                                       "/"],
  ["/traindriver",                                                                                "/what-does-a-train-driver-do"],
  ["/elearning",                                                                                  "/cpd"],
  ["/introduction-to-train-systems",                                                              "/introduction-to-traction-and-rolling-stock"],
  ["/PTS",                                                                                        "/introduction-to-personal-track-safety"],
  ["/interview-guidance",                                                                         "/interview"],
  ["/how-to-become-a-train-driver",                                                               "/become-a-driver"],


  // ----- Wix demo blog stubs (never had real content) ------------------------
  ["/tips-for-writing-great-posts-that-increase-your-site-traffic",                               "/"],
  ["/keep-in-touch-with-site-visitors-and-boost-loyalty",                                         "/"],
  ["/make-the-most-of-the-season-by-following-these-simple-guidelines",                           "/"],

  // ----- CPD courses --------------------------------------------------------
  ["/intrototrainsystems",                                                                        "/cpd"],
  ["/intrototrainsystems/",                                                                       "/cpd"],
  ["/intrototrainsystems/CPD-Courses-c119987839",                                                 "/cpd"],
  ["/intrototrainsystems/Products-c119987376",                                                    "/cpd"],
  ["/PTS/Products-c119987376",                                                                    "/cpd"],
  ["/training",                                                                                   "/cpd"],
  ["/intrototrainsystems/cart",                                                                   "/cpd"],

  // Pre-Employment Training (multiple legacy paths)
  ["/intrototrainsystems/Train-Driver-Pre-Employment-Training-PET-Level-3-CPD-40-Hours-p299536476", "/cpd/pre-employment-training"],
  ["/PTS/Train-Driver-Pre-Employment-Training-PET-Level-3-CPD-40-Hours-p299536476",                "/cpd/pre-employment-training"],
  ["/store/TDF-Level-3-Certificate-Train-Driving-Pre-Employment-Training-PET-p299536476",         "/cpd/pre-employment-training"],
  ["/Train_Driver_Pre_Employment_Training_PET",                                                   "/cpd/pre-employment-training"],
  ["/Train_Driver_Pre_Employment_Training",                                                       "/cpd/pre-employment-training"],
  ["/pre-employment-training",                                                                    "/cpd/pre-employment-training"],

  // Introduction to Train Driving (Level 2)
  ["/intrototrainsystems/Introduction-to-Train-Driving-Level-2-CPD-15-Hours-p301474947",          "/cpd/introduction-to-train-driving"],

  // Introduction to Traction & Rolling Stock (Level 2)
  ["/intrototrainsystems/Introduction-to-Traction-and-Rolling-Stock-Level-2-CPD-15-Hours-p301480805", "/cpd/introduction-to-traction-and-rolling-stock"],

  // Introduction to Personal Track Safety (PTS, Level 2)
  ["/PTS/Introduction-to-Personal-Track-Safety-PTS-Level-2-CPD-15-Hours-p622490284",              "/cpd/introduction-to-personal-track-safety"],

  // How to Become a Train Driver
  ["/intrototrainsystems/How-to-Become-a-Train-Driver-p719525908",                                "/become-a-driver"],
  ["/becoming-a-train-driver",                                                                    "/become-a-driver"],
  ["/how",                                                                                        "/become-a-driver"],
  ["/application",                                                                                "/become-a-driver"],

  // ----- Products / preparation services ------------------------------------
  // Detailed Interview Guide → Interview Prep page
  ["/intrototrainsystems/Detailed-Interview-Guidance-p299523773",                                 "/interview"],

  // CV Review
  ["/intrototrainsystems/CV-Review-Service-p299514618",                                           "/cv"],

  // Psychometric assessment
  ["/intrototrainsystems/Train-Driver-Psychometric-Assessment-Complete-Guide-p724144980",         "/psychometrics"],
  ["/PTS/Train-Driver-Psychometric-Assessment-Complete-Guide-p724144980",                         "/psychometrics"],
  ["/psychometric",                                                                               "/psychometrics"],
  ["/train-driver-psychometric-tests",                                                            "/psychometrics"],

  // Complete Career Package / Full Application Pack
  ["/intrototrainsystems/Complete-Career-Package-p733117598",                                     "/complete-career-package"],
  ["/PTS/Complete-Career-Package-p733117598",                                                     "/complete-career-package"],
  ["/intrototrainsystems/Full-Application-Pack-p724144250",                                       "/complete-career-package"],
  ["/PTS/Full-Application-Pack-p724144250",                                                       "/complete-career-package"],
  ["/full-application-package",                                                                   "/complete-career-package"],

  // ----- Account / generic ---------------------------------------------------
  ["/intrototrainsystems/account",                                                                "/my-account"],
  ["/PTS/account",                                                                                "/my-account"],
  ["/career",                                                                                     "/careers"],
  ["/careersdcbc92fd",                                                                            "/careers"],
];
